<template>
    <div>
        <Row style="margin-bottom: 14px;" :gutter="4">
            <div v-if="company==1">
                <Col span="4">
                    <Select v-model="companyId" filterable :placeholder="$t('ApprovalTask.selectByCompany')" :transfer="true" @on-change="searchCompany">
                        <Option value=" " selected>{{$t('ApprovalTask.selectAll')}}</Option>
                        <Option :value="item.id" v-for="item in companyList" :key="item.id">{{item.name}}</Option>
                    </Select>
                </Col>
            </div>
            <Col span="4">
                <Select filterable v-model="approvalNameSearchKey" :placeholder="$t('ApprovalTask.selectByType')" :transfer="true" @on-change="searchApproval()">
                    <Option value="">{{$t('ApprovalTask.selectAll')}}</Option>
                    <Option :value="item.id" v-for="item in typeList" :key="item.id">{{item.name}}</Option>
                </Select>
            </Col>
        </Row>
        <table-approval-task></table-approval-task>
    </div>
</template>
<script>
   import {setCookie,getCookie} from '../../../utils/cookieUtil.js'

  import TableApprovalTask from '../approval_task/TableApprovalTask'
    var tableApprovalTask = TableApprovalTask;
    export default {
        name: 'ApprovalTaskSearch',
        components: {
            TableApprovalTask
        },
        data () {
            return {
                company: getCookie(global.companyId),
                companyId: '',
                companyList: [],
                approvalNameSearchKey:'',
                approvalNameSearchID:'',
                typeList:[]
            }
        },
        mounted: function(){
            this.approvalTypes();
            if (this.company == 1) {
              this.getCompanyDropDownBox();
            }
        },
        methods: {
            approvalTypes: function(){
                this.$api.processTask.approvalTypes()
                .then(res => {
                    this.typeList = res.data;
                });
            },
            // 获取公司下拉框
            getCompanyDropDownBox: function(){
              this.$api.company.getCompanyDropDownBox("userName",getCookie(global.cookieName))
                .then(res => {
                  this.companyList = res.data;
                });
            },
            // 按公司搜索
            searchCompany: function(){
                eventBus.$emit('companyId', this.companyId);
                tableApprovalTask.methods.showAll();
            },
            searchApproval: function(){
                eventBus.$emit('approvalNameSearchID', this.approvalNameSearchKey);
                tableApprovalTask.methods.showAll();
            }
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/approval_task/approval_task/ApprovalTaskSearch.vue